import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './i18n';
import { installNumberInputWheelGuard } from './utils/numberInputWheelGuard';

// Never let a mouse wheel silently change an amount field (see the util).
installNumberInputWheelGuard();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
